import {DialogBody, DialogFooter} from '@/components/ui/dialog-atoms/DialogAtoms'
import styled, {css} from 'styled-components'

export const StyledExportSiarDialogBody = styled(DialogBody)(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * 4}px;
    `
)

export const StyledExportSiarDialogFooter = styled(DialogFooter)(
    ({theme: {spacing}}) => css`
        display: flex;
        gap: ${spacing * 2}px;
        justify-content: flex-end;
    `
)
